import React from 'react'
import { Modal } from 'rsuite'

const ByPassModal = ({ show, onClose, onConfirm }) => {

  return (
    <Modal
      backdrop={true}
      className="bypass-modal"
      show={show}
      size="sm"
      onClick={onClose}
      onHide={onClose}
    >
      <Modal.Header>
        <Modal.Title className='fw-bold'>
          Bypass and Import Data
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="content">
          <div className="row flex">
            <h4>
                You are attempting to import data that is missing one of the required fields.
                Do you wish to bypass this and import the data anyway?
            </h4>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="action-container">
          <button type="button" className="btn btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn btn-confirm" onClick={onConfirm}>
            Ok
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
export default ByPassModal